import { activeLayerVisualizationMeasureSettingsPath } from '../contracts/httpPaths';
import {
  ActiveLayerVisualizationMeasureSettingsPatchBody,
  ActiveLayerVisualizationMeasureSettingsResponse,
} from '../contracts/visualizationMeasureSettings';

import { surveyDataManagerClient, toSurveyDataManagerApiError } from './httpClient';

export async function getActiveLayerVisualizationMeasureSettings(
  instanceId: string,
): Promise<ActiveLayerVisualizationMeasureSettingsResponse | null> {
  try {
    const response = await surveyDataManagerClient.get<ActiveLayerVisualizationMeasureSettingsResponse>(
      activeLayerVisualizationMeasureSettingsPath(instanceId),
    );
    return response.data;
  } catch (error) {
    const apiError = toSurveyDataManagerApiError(error);
    if (apiError.status === 404) {
      return null;
    }
    throw apiError;
  }
}

export async function patchActiveLayerVisualizationMeasureSettings(
  instanceId: string,
  body: ActiveLayerVisualizationMeasureSettingsPatchBody,
): Promise<ActiveLayerVisualizationMeasureSettingsResponse> {
  try {
    const response =
      await surveyDataManagerClient.patch<ActiveLayerVisualizationMeasureSettingsResponse>(
        activeLayerVisualizationMeasureSettingsPath(instanceId),
        body,
      );
    return response.data;
  } catch (error) {
    throw toSurveyDataManagerApiError(error);
  }
}
